if (!customElements.get('sakura-corporate-product')) {
  customElements.define('sakura-corporate-product', class extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('sakura-corporate-product-theme');
    }

    disconnectedCallback() {
      if (!document.querySelector('sakura-corporate-product')) {
        document.documentElement.classList.remove('sakura-corporate-product-theme');
      }
    }
  });
}
